import * as React from "react";
import { useEffect, useMemo } from "react";
import { useSelector } from "react-redux";
import { createTheme, ThemeProvider, useMediaQuery } from "@mui/material";
export default function AppThemeProvider({ children }) {
    const mode = useSelector((state) => state.theme.mode);
    const prefersDark = useMediaQuery('(prefers-color-scheme: dark)', { noSsr: true });
    const paletteMode = mode === 'system' ? (prefersDark ? 'dark' : 'light') : mode;
    // lets plain SCSS (app.scss) follow the theme too
    useEffect(() => {
        document.documentElement.setAttribute('data-theme', paletteMode);
    }, [paletteMode]);
    const theme = useMemo(() => createTheme({ palette: { mode: paletteMode } }), [paletteMode]);
    return React.createElement(ThemeProvider, { theme: theme }, children);
}
